import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/bluforce.css';
import App from './App.js';
import { AuthProvider } from './auth/AuthContext.js';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Missing #root element');

// BLUF-715 — Quick Quote's navigation guard uses React Router's
// `useBlocker`, which only works inside a data router. The legacy
// declarative `<BrowserRouter>` wrapper throws "useBlocker must be
// used within a data router" the moment QuotePage mounts. The data
// router below keeps the existing single-tree <Routes> structure
// inside App by giving it a catch-all route; nested <Routes> work
// the same way they did under <BrowserRouter>.
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <AuthProvider>
        <App />
      </AuthProvider>
    ),
  },
]);

createRoot(rootElement).render(<RouterProvider router={router} />);
